import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class SiesMassive extends Api {
    constructor(http, config = {}) {
        super(http, url, 'massive-siesUser', config);
    }
}